import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import BackButton from "../components/BackButton";
import { useAuth } from "../contexts/AuthContext";
import { centerAlignItems } from "../utils/styles";
import { FileUploader } from "react-drag-drop-files";
import { useSnackbar } from "../contexts/SnackbarProvider";

const AddNewPage = ({ onBack, unitId }) => {
  const Auth = useAuth();
  const { setSnackbarDetail } = useSnackbar();
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [needRefresh, setNeedRefresh] = useState(false);
  function addPage(e) {
    e.preventDefault();
    setIsUploading(true);
    let formData = new FormData();
    formData.append("title", e.target.title.value);
    formData.append("leftImage", image1);
    formData.append("rightImage", image2);
    formData.append("unitId", unitId);
    Auth.AuthenticatedServerCall({
      method: "post",
      isFormData: true,
      body: formData,
      entity: "api/pages",
    })
      .then((res) => {
        setNeedRefresh(true);
        setSnackbarDetail({
          open: true,
          message: "page add successfully.",
          severity: "success",
        });
        e.target.reset();
        setImage1(null);
        setImage2(null);
        setIsUploading(false);
      })
      .catch((e) => {
        setIsUploading(false);
        console.log("error");
      });
  }
  return (
    <Box
      component="form"
      onSubmit={addPage}
      sx={centerAlignItems}
      className="md-addNewPage"
    >
      <BackButton onBack={() => onBack(needRefresh)} />
      <TextField
        sx={{ m: 1, minWidth: "400px" }}
        label="title"
        id="title"
        required
      />
      <Typography variant="body1" textAlign="left" sx={{ mt: 2 }}>
        Left Image
      </Typography>
      <FileUploader
        handleChange={(img) => setImage1(img)}
        name="image1"
        types={["JPG", "PNG", "JPEG"]}
      />
      <Typography variant="caption" sx={{ mb: 2 }}>
        {image1?.name}
      </Typography>

      <Typography variant="body1" textAlign="left">
        Right Image
      </Typography>
      <FileUploader
        handleChange={(img) => setImage2(img)}
        name="image2"
        types={["JPG", "PNG", "JPEG"]}
      />
      <Typography variant="caption">{image2?.name}</Typography>

      <Button
        type="submit"
        variant="contained"
        sx={{ m: 1, minWidth: "200px" }}
        disabled={isUploading}
      >
        {isUploading ? <CircularProgress /> : "save"}
      </Button>
    </Box>
  );
};

export default AddNewPage;
